/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  DeleteLegacyProductMutationResponse,
  DeleteLegacyProductPathParams,
  DeleteLegacyProduct400,
  DeleteLegacyProduct404,
} from '../types/DeleteLegacyProduct'

function getDeleteLegacyProductUrl({
  id,
}: {
  id: DeleteLegacyProductPathParams['id']
}) {
  const res = { method: 'DELETE', url: `/api/v1/products/${id}/` as const }
  return res
}

/**
 * @summary Delete a product (legacy endpoint)
 * {@link /api/v1/products/:id/}
 */
export async function deleteLegacyProduct(
  { id }: { id: DeleteLegacyProductPathParams['id'] },
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    DeleteLegacyProductMutationResponse,
    ResponseErrorConfig<DeleteLegacyProduct400 | DeleteLegacyProduct404>,
    unknown
  >({
    method: 'DELETE',
    url: getDeleteLegacyProductUrl({ id }).url.toString(),
    ...requestConfig,
  })
  return res.data
}
